export const FORM_NAME = 'cargo-fetch-form';

export const REQUIRED_FIELDS = [
	'date_arrival',
	'time_arrival',
	'date_departure',
	'time_departure',
	'type',
	'state',
	'options_points',
	'container_state',
	'packaging_state',
	'body_state',
];

export const POINT_REQUIRED_FIELDS = ['type_seat', 'weight', 'volume', 'place'];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';
